import './style.scss';



function AboutUs (setIsOpened) {

    return(
        <section className='screen-aboutus' style={{backgroundImage:'url(/img/synlab.jpg)'}}>
            <div className='container'>
                <article className='main-article'>
                    <h1 className='title'>
                        RÓLUNK
                    </h1>
                    <div className='description'>
                        <p>
                        A Váci Belvárosi Egészségközpont (VBEK) 2018 óta nyújt magas színvonalú, megbízható egészségügyi szolgáltatásokat a belváros szívében, könnyen megközelíthető helyen. Tapasztalt szakembereink modern eszközökkel biztosítják a gyors diagnosztikát és a személyre szabott ellátást, miközben pácienseink barátságos, empatikus környezetben kapják meg a legjobb gondoskodást. Célunk, hogy minden hozzánk forduló számára kiemelkedő minőségű szolgáltatást nyújtsunk, ahol az egészség és a páciens elégedettsége az első. Látogasson el hozzánk a váci Zrínyi utca 3-ba, és tapasztalja meg a gondoskodó, minőségi egészségügyi ellátást!
                        </p>
                    </div>
                </article>
            </div>
        </section>
    )
}

export default AboutUs;